<template>
  <div>
    <BjDrawerForm
      ref="BjDrawerForm"
      :form="form"
      :rules="rules"
      label-width="130px"
      width="1100px"
      @handleConfirm="handleConfirm"
    >
      <template>
        <BjDivider>{{ $t('goodsPage.package.Info') }}
          <template slot="right">
            <el-button type="primary" @click="addPackage">{{ $t('addText') }}</el-button>
          </template>
        </BjDivider>
        <el-table :data="form.PackageVOList" border script>
          <el-table-column type="index" :label="$t('table.countText')" width="60" align="center" />
          <el-table-column prop="packingMethod" :label="$t('goodsPage.package.Method')" align="center" >
            <template slot-scope="scope">{{ $t(PACKAGE_TYPE_LIST.bjGet(scope.row.packingMethod)) }}</template>
          </el-table-column>
          <el-table-column prop="name" :label="$t('goodsPage.package.Name')" align="center" />
          <el-table-column prop="sku" :label="$t('goodsPage.package.SKU')" align="center" />
          <el-table-column prop="qty" :label="$t('goodsPage.package.num')" align="center" />
          <el-table-column prop="materialFee" :label="$t('goodsPage.package.money1')" align="center" >
            <template slot-scope="scope">{{ scope.row.materialFee }}</template>
          </el-table-column>
          <el-table-column prop="labourFee" :label="$t('goodsPage.package.money2')" align="center" >
            <template slot-scope="scope">{{ scope.row.labourFee }}</template>
          </el-table-column>
          
          <el-table-column :label="$t('table.operationText')" align="center" width="100">
            <template slot-scope="{ row, $index }">
              <el-button type="text" @click="onDelete(row, $index)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </BjDrawerForm>
    <!-- 包材 新增弹窗 -->
    <BjDialog :title="$t('goodsPage.package.Info')" :visible="packageVisible" width="400px" @close="clearVisible()">
      <el-form ref="packageForm" :model="packageForm" :rules="rules" label-width="100px" label-position="top">
          <el-form-item :label="$t('goodsPage.package.SKU')" prop="packageName">
            <BjSelectLov v-model="packageForm.packageName" :option-list="packageList" :placeholder="$t('goodsPage.package.Name')" @change="logPackage"/>
          </el-form-item>
          <el-form-item :label="$t('goodsPage.package.num')" prop="qty">
            <BjInputNumber v-model="packageForm.qty" :placeholder="$t('goodsPage.package.num')" />
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearVisible()">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="confirmPackage">{{ $t('okText') }}</el-button>
      </span>
    </BjDialog>
  </div>
</template>
<script>
import { goodsApi,orderApi } from '@/api';
import { PACKAGE_TYPE_LIST } from '@/utils/constants';

const getDefaultForm = () => {
  return {
    id: null,
    PackageVOList: [],
  };
};

export default {
  data() {
    return {
      PACKAGE_TYPE_LIST,
      form: getDefaultForm(),
      // 选中数据列表
      selection: [],
      // 包材新增弹窗
      packageVisible:false,
      // 包材新增弹窗form
      packageForm: {
        packageName: '',
        qty: '',
      },
      // 包材新增弹窗rules
      rules: {
        packageName: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        qty: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      },
      // 包材新增弹窗 包材下拉列表
      packageList:[],
      // 侧边栏 包材名称
      packageSkuNmae:null,
      // 侧边栏 材料费
      salesPrice:null,
      // 侧边栏 人工费
      activityPrice:null,
      // 删除列表，传参用
      deleteList:[],
    };
  },
  methods: {
    show(info) {
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle((this.$t('editText')+' '+this.$t('goodsPage.package.Info')));
      this.form = Object.assign(getDefaultForm(), info || {});
      // 获取侧边栏数据
      orderApi.getOrderPackageList({innerOrderNo: info.innerOrderNo}).then(res => {
        this.form.PackageVOList = res || []
        // 侧边栏保存按钮传参用
        this.deleteList = res.map(resp => resp.id)
      })
      // 获取 侧边栏中新增弹窗里的 包材下拉数据
      goodsApi.getPackageNameList({innerOrderNo: info.innerOrderNo}).then(res=>{
        this.packageList = res.map(item => {
          return { label: item.skuCode, value: item.skuCode ,event: item};
        });
      })
    },
    // 侧边栏 新增按钮
    addPackage() {
      this.packageVisible = true
    },
    // 赋值给skuname
    logPackage(n,m){
      this.packageSkuNmae = m.event.skuName
      this.salesPrice = m.event.salesPrice
      this.activityPrice = m.event.activityPrice
    },
    // 弹出框 保存
    confirmPackage(){
      this.$refs.packageForm.validate(valid => {
        if (valid) {
          this.form.PackageVOList.push({
            packingMethod: 'order',
            name: this.packageSkuNmae,
            sku: this.packageForm.packageName,
            qty: this.packageForm.qty,
            materialFee: (this.salesPrice * this.packageForm.qty).toFixed(2),
            labourFee: (this.activityPrice * this.packageForm.qty).toFixed(2),
          });
          this.$message.success(this.$t('toast.operationSuccessText'));
          // 清空数据并关闭弹出框
          this.clearVisible()
        }
      })
    },
    // 清空数据并关闭弹出框
    clearVisible(){
      this.$refs.packageForm.resetFields();
      this.packageVisible = false
      this.packageSkuNmae = null
    },
    // 侧边栏 删除
    onDelete(row, index) {
      this.$MessageBox({ content: this.$t('toast.deletionConfirmationText') }).then(() => {
        this.form.PackageVOList.splice(index, 1)
        this.msgSuccess(this.$t('toast.deleteSuccessText'));
      });
    },
    // 侧边栏 保存
    handleConfirm() {
      const API_DATA = {
        code:this.form.innerOrderNo,
        deleteList:this.deleteList,
        list:this.form.PackageVOList.map(item => {
          return { sku: item.sku, qty: item.qty ,packingMethod: item.packingMethod};
        })
      };
      orderApi.addWebPacking(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
    reFresh() {
      this.$emit('reFresh');
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
